module.exports = __webpack_public_path__ + "img/bell-04.e0c8ab70.svg";